import { GUIDE_JUMP_TO } from "../constants/bus-events-constants";

export default {
    computed: {
        footerButtonText() {
            return this.guide ? this.$t('ui.back') : this.$t('ui.close');
        },
        footerButtonTheme() {
            return this.guide ? 'back' : 'close';
        }
    },
    methods: {
        handleCloseClick() {
            if (this.guide) this.$emit('onClose', true);
            else this.redirectToHome();
        },
        handleFooterClick() {
            if (this.guide) this.$bus.$emit(GUIDE_JUMP_TO, 'menu');
            else this.redirectToHome();
        },
        redirectToHome() {
            const params = {
                name: 'web.start'
            };
            this.$router.push(params);
        }
    }
}